//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import homeHeader from './home/header';
import homeFooter from './home/footer';
import csrDialog from './customerService/csrDialog';
import backToTop from './common/backToTop.vue';
import wxScanLogin from './home/wxLogin.vue';
import pwdLogin from './home/login.vue';
export default {
    mixins: [],
    components: {
        homeHeader,
        homeFooter,
        csrDialog,
        wxScanLogin,
        pwdLogin,
        backToTop
    },
    data() {
        return {
               loginType: '0', // 控制登录方式  0 微信登录;  1 密码登录
        };
    },
    methods: {
        // 联系客服
        toCsr() {
            if (sessionStorage.token) {
                this.$store.state.pcCsrShow = true;
            } else {
                // this.$vux.toast.text(' 请先登录');
                this.$store.state.pcLoginShow = true;
            }
        }
    },
    mounted() {
        this.$store.state.pcMAINPAGE = this;
        if (operatingEnv === 'prod') {
            this.loginType = '0';
        } else {
            this.loginType = '1';
        }
    }
};



// WEBPACK FOOTER //
// ./src/pcComponents/main.vue